/**
 * The heading and "Already have an account? Log in" copy of `RegisterForm.tsx`. The form's field
 * labels and button label are English literals in that file, not here.
 */
import { LanguageContent } from "@components/Shared/model/LanguageContent";

/** Copy keys of the registration form's heading area. */
export interface RegisterFormInstance {
	logIn: string;
	openNew: string;
	alreadyHave: string;
}

/** Registration form heading copy, by site language. */
export const RegisterFormContent: LanguageContent<RegisterFormInstance> = {
	en: {
		logIn: "Log in",
		openNew: "Open a new account",
		alreadyHave: "Already have an account?",
	},
	fr: {
		logIn: "Se connecter",
		openNew: "Ouvrir un nouveau compte",
		alreadyHave: "Vous avez déjà un compte?",
	},
	es: {
		logIn: "Connectarse",
		openNew: "Abrir una nueva cuenta",
		alreadyHave: "Ya tiene una cuenta?",
	},
};
